// @flow

// ------------------------------------------------------
// -
// -    Codes erreurs
// -
// ------------------------------------------------------

export const UNKNOWN_ERROR: number = 0;
export const FORM_ERROR: number = 1;
export const TOKEN_INVALID: number = 2;
export const TOKEN_RESET_FAILED: number = 3;
export const EMAIL_SEND_FAILED: number = 4;
export const PASSWORD_RESET_FAILED: number = 5;
export const USER_DEACTIVATED: number = 6;
export const CATEGORY_MOVE_DIRECTION_INVALID: number = 7;
export const CATEGORY_MOVE_DELTA_INVALID: number = 8;
export const CATEGORY_MOVE_FAILED: number = 9;
export const MANUFACTURER_LINKED_ERROR: number = 10;
export const ADCONDITION_LINKED_ERROR: number = 11;
export const USER_EMAIL_CONFIRMATION_PENDING: number = 12;
export const USER_ALREADY_EXISTS: number = 13;
export const USER_ACTIVATION_ERROR: number = 14;
export const AD_APPROVE_ERROR: number = 15;
export const AD_DISABLE_ERROR: number = 16;
export const AD_ENABLE_ERROR: number = 17;
export const AD_MEDIA_MAX_ERROR: number = 18;
export const AD_DEPICT_ERROR: number = 19;
export const AD_MEDIA_MIN_ERROR: number = 20;
export const AD_MEDIA_SORT_ERROR: number = 22;
export const ORDER_CREATE_FAILED: number = 23;
export const ORDER_PAYMENT_SETUP_FAILED: number = 24;
export const STRIPE_PAYLOAD_INVALID: number = 25;
export const ORDER_PAYMENT_CANCEL_FAILED: number = 26;
export const AD_SET_PRICE_ERROR: number = 27;
export const AD_BAN_FAILED: number = 28;
export const AD_UNBAN_FAILED: number = 29;
export const AD_EXTEND_ERROR: number = 30;
export const AD_ORDER_DELETE_ERROR: number = 31;
export const CREDIT_USE_FAILED: number = 32;
export const CREDIT_NOT_ENOUGH: number = 33;
export const SHOWCASE_MEDIA_MIN_ERROR: number = 34;
export const SHOWCASE_MEDIA_MAX_ERROR: number = 35;
export const SHOWCASE_MEDIA_SORT_ERROR: number = 36;
export const BANNER_FIELD_ERROR: number = 37;
